import * as Actions from '../actions'

const initialState = {
    data: null
}

const manageWorkspacesReducer = function (state=initialState, action) {
    switch(action.type){
        case Actions.MANAGE_KUBE_WORKSPACES:
        {
            return {
                ...state,
                data: action.payload
            }
        }
        default:
        {
            return state
        }
    }
}

export default manageWorkspacesReducer